module.exports = __webpack_public_path__ + "img/SMSC15105-min.5e1faf86.png";